import AppShell from "@/components/layout/AppShell";
import PageHeader from "@/components/ui/PageHeader";
import { Table, TD, TH, THead } from "@/components/ui/Table";
import { store } from "@/lib/store";
import { peso } from "@/lib/utils";

export default function OrdersPage() {
    const orders = store.getOrders();

    return (
        <AppShell>
            <PageHeader title="Orders" description="Manual and social-media sales orders." />
            <Table>
                <table className="min-w-full border-collapse">
                    <THead>
                        <tr>
                            <TH>Order #</TH>
                            <TH>Customer</TH>
                            <TH>Channel</TH>
                            <TH>Payment</TH>
                            <TH>Fulfillment</TH>
                            <TH>Total</TH>
                        </tr>
                    </THead>
                    <tbody>
                        {orders.map((order) => (
                            <tr key={order.id} className="border-t border-rose-50">
                                <TD>{order.orderNumber}</TD>
                                <TD>{order.customerName}</TD>
                                <TD>{order.channel}</TD>
                                <TD>{order.paymentStatus}</TD>
                                <TD>{order.fulfillmentStatus}</TD>
                                <TD>{peso(order.totalAmount)}</TD>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Table>
        </AppShell>
    );
}